import axios from 'axios';
const {REACT_APP_FILE_UPLOAD_URL: FILE_UPLOAD_URL} = process.env;
const uploadFile = async (formData) => {
  const files = formData.getAll('file');

  if (!files || files.length === 0) {
    throw new Error('No files uploaded');
  }

  try {
    // Prepare the request payload
    const fileDetails = Array.from(files).map((file) => ({
      fileName: file.name,
      mimeType: file.type,
    }));

    // console.log('fileDetails', fileDetails);

    // Request presigned URLs from the backend
    const response = await axios.post(FILE_UPLOAD_URL, {
      files: fileDetails,
    });

    const {presignedUrls} = response.data;

    // Upload each file using the presigned URL
    await Promise.all(
      presignedUrls.map(async ({fileName, signedUrl}) => {
        const file = Array.from(files).find((f) => f.name === fileName);

        const fileBlob = new Blob([file], {type: file.type});

        await axios.put(signedUrl, fileBlob, {
          headers: {
            'Content-Type': file.type,
          },
        });
      })
    );

    const hostedUrl = presignedUrls.map((item) => {
      return item.hostedUrl;
    });

    return hostedUrl;
  } catch (error) {
    console.error('Error uploading files:', error);
    throw error;
  }
};

export {uploadFile};
